import { useTranslation } from "react-i18next";
import { Link, isRouteErrorResponse, useRouteError } from "react-router";

export function RouteError() {
  const error = useRouteError();
  const { t } = useTranslation();
  if (import.meta.env.DEV) console.error(error);
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  return (
    <main className="mx-auto grid min-h-dvh max-w-md content-center gap-3 p-6 text-center">
      <h1 className="text-xl font-semibold">{notFound ? t("error.notFound") : t("error.title")}</h1>
      {!notFound && <p className="text-muted-foreground">{t("error.body")}</p>}
      <Link to="/" className="text-primary underline underline-offset-4">
        {t("error.backHome")}
      </Link>
    </main>
  );
}
